import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { ILinksToCardsPanelButtonProps } from './types';
import { LINKS_TO_CARDS_BUTTON } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function LinksToCardsPanelButton ({
    indicatorBoolean,
    isDisabled,
    tooltip,
    onClick
}: ILinksToCardsPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.LINKS_PREVIEW}
            indicatorBoolean={indicatorBoolean}
            isDisabled={isDisabled}
            title={LINKS_TO_CARDS_BUTTON}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.LINKS_PREVIEW)
                onClick();
            }}
        />
    );
}
